import { useEffect, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../contexts/AuthContext';
import { UIContext } from '../../contexts/UIContext';

import { useGeoLocation } from '../../hooks/useGeoLocation';
import { useGetCityVectorFoci } from '../../hooks/useVectorFocusService';
import { useGetWorkingAreasSelector } from '../../hooks/useWorkingAreasService';

import Header from '../../components/Header/Header';
import BottomMenu from '../../components/BottomMenu/BottomMenu';
import MapVisualizer from '../../components/MapVisualizer/MapVisualizer';
import MapFilterOptions from '../../components/MapFilterOptions/MapFilterOptions';
import MapFilterModal from '../../components/MapFilterModal/MapFilterModal';
import RoundButton from '../../components/RoundButton/RoundButton';
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import './VectorFocusMonitoring.scss';

function VectorFocusMonitoring() {
  const { authUser, isAuthorized } = useContext(AuthContext);
  const {showErrorMessage} = useContext(UIContext);

  const [cityVectorFociRefreshCount, setCityVectorFociRefreshCount] = useState(0);

  const navigate = useNavigate();
  const [lat, lng, errGeoLocation] = useGeoLocation();
  const [, workingAreas, agentWorkingArea] = useGetWorkingAreasSelector({
    cityId: authUser?.roles?.agent?.city?.id,
    agentId: authUser?.roles?.agent?.id
  });
  const [, cityVectorFoci] = useGetCityVectorFoci({
    cityId: authUser?.roles?.agent?.city?.id,
    reload: cityVectorFociRefreshCount
  });
  let userGeolocation = { lat, lng };

  const [showPins, setShowPins] = useState(true);
  const [showWorkingAreas, setShowWorkingAreas] = useState(false);
  const [showHeatmap, setShowHeatmap] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showUserLocation, setShowUserLocation] = useState(false);

  useEffect(() => {
    if (!isAuthorized) navigate('/login');
  }, [isAuthorized, navigate]);

  useEffect(() => {
    if (errGeoLocation) {
      showErrorMessage({
        message: "Precisamos de ter acesso à sua geolocalização para utilizar esta funcionalidade"
      })
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errGeoLocation]);

  function handleShowFilter() {
    setShowFilter(!showFilter);
  }

  function handleCloseFilter() {
    setShowFilter(false);
    setCityVectorFociRefreshCount(cityVectorFociRefreshCount + 1);
  }

  function handleClickCurrentLocation() {
    setShowUserLocation(!showUserLocation);
  }

  return (
    <div className="inner-page vector-focus-monitoring-page">
      <Header
        showBackBtn
        hideBackBtnLabel
        pageTitle="Monitoramento"
      />
      <div className="map-container">
        {lat && lng && (
          <MapVisualizer
            className="monitoring-map"
            workingAreas={workingAreas}
            workingArea={agentWorkingArea}
            vectorFoci={cityVectorFoci}
            heatmapData={cityVectorFoci}
            userLocation={userGeolocation}
            showPins={showPins}
            showWorkingAreas={showWorkingAreas}
            showHeatmap={showHeatmap}
            showUserLocation={showUserLocation}
          />
        )}
      </div>
      <MapFilterOptions
        handleShowPins={setShowPins}
        handleShowPolygons={setShowWorkingAreas}
        handleShowHeatmap={setShowHeatmap}
        handleClickCurrentLocation={handleClickCurrentLocation}
      />
      <RoundButton
        className="map-filter-container"
        buttonIcon={<FilterAltIcon />}
        handleOnClick={handleShowFilter}
      />
      <MapFilterModal
        showFilter={showFilter}
        handleCloseFilter={handleCloseFilter}
      />
      <BottomMenu />
    </div>
  );
}

export default VectorFocusMonitoring;
